var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ratioContainer",style:(_vm.containerStyle)},[_c('picture',[_c('source',{attrs:{"type":"image/webp","data-srcset":_vm.widths.map(function (w) { return (
            _vm.imageUrl
              .image(_vm.source)
              .width(w)
              .height(parseInt(w / _vm.ratio, 10))
              .fit(_vm.fit || 'crop')
              .format('webp')
              .quality(80)
              .url() + " " + w + "w"
          ); }).join(', ')}}),_vm._v(" "),_c('source',{attrs:{"data-srcset":_vm.widths.map(function (w) { return (
            _vm.imageUrl
              .image(_vm.source)
              .width(w)
              .height(parseInt(w / _vm.ratio, 10))
              .fit(_vm.fit || 'crop')
              .format(_vm.transparent ? 'png' : 'jpg')
              .quality(80)
              .url() + " " + w + "w"
          ); }).join(', ')}}),_vm._v(" "),_c('img',{ref:"imageEl",staticClass:"lazyload blurUp",attrs:{"data-parent-fit":"contain","src":_vm.lqip,"data-sizes":"auto","alt":_vm.alt}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6acd6914","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageSource.vue
// module id = 487
// module chunks = 1